import React from "react";
import { Form } from "react-bootstrap";
// import { useField } from 'formik';
import Datetime from "react-datetime";

const SelectDateTime = ({ label, timeFormat, name, onChange, error, ...props }) => {
    // const [field,meta,helpers] = useField(props);
    return (
        <Form.Group controlId={name}>
            <Form.Label>{label}</Form.Label>
            <Datetime
                {...props}
                // className="dt-custom-date"
                timeFormat={timeFormat}
                dateFormat={false}
                name={name}
                inputProps={{ placeholder: "" }}
                onChange={onChange}
                input={true}
                // open={null}
                utc={true}
            />
            {!!error ? <div className="text-danger">{error}</div> : null}
        </Form.Group>
    );
};

SelectDateTime.defaultProps = {
    timeFormat: "HH:mm",
    error: ""
};

export default SelectDateTime;
